import React, { useRef, useState } from 'react';
import SelectUsers from './SelectUsers';
import Functions from '../../api/Functions';
import Loading from '../generalComponets/Loading';

function ResetQuestions() {
  const [showProcess, setShowProcess] = useState(false);
  const [validUsers, setValidUsers] = useState(true);
  const childRef = useRef();

  const resetQuestions = () => {
    const profiles = childRef.current.getProfiles();
    if (profiles && profiles.length > 0) {
      setValidUsers(true);
      const userIds = profiles.map((user) => user.id);
      setShowProcess(true);
      Functions.resetQuestions(userIds)
        .then(() => {
          setShowProcess(false);
        })
        .catch(() => {
          setShowProcess(false);
        });
    } else {
      setShowProcess(false);
      setValidUsers(false);
    }
  };

  return (
    <div className="container">
      <div className="title-section">Reset Questions</div>
      {showProcess ? <Loading /> : <div />}
      <div className="row">
        <div className="col s6">
          <button className="btn" onClick={resetQuestions}>
            Reset Questions
          </button>
          {!validUsers ? <h6 className="red-text">Select Users</h6> : <div />}
        </div>
        <div className="col s6">
          <SelectUsers ref={childRef} />
        </div>
      </div>
    </div>
  );
}

export default ResetQuestions;
